import { render, staticRenderFns } from "./IndexColumn.vue?vue&type=template&id=6bbb3a38&scoped=true&"
import script from "./IndexColumn.vue?vue&type=script&lang=js&"
export * from "./IndexColumn.vue?vue&type=script&lang=js&"
import style0 from "./IndexColumn.vue?vue&type=style&index=0&id=6bbb3a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb3a38",
  null
  
)

export default component.exports